<template>
  <tr class="car-class-row">
    <td>
      {{ carClass.name }}
    </td>
    <td>
      {{ carClass.CarTypes.length }}
    </td>
    <td>
      <router-link class="btn btn-sm btn-primary"
            :to="{ path: `/fleet/vehicles/classes/edit/${carClass.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'CarClassRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    carClass () {
      return {
        CarTypes: [],
        Rates: [],
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/CarClass.vue